import React, { CSSProperties, useEffect, useRef } from "react";

interface ScrollToProps { 
  to: string;
  id: string;
  className?: string;
  style?: CSSProperties;
}

export default function ScrollTo(props: ScrollToProps) {
  const { to, id, className, style } = props;

  const node = useRef<HTMLAnchorElement>(null);

  useEffect(() => {
    node.current?.addEventListener("click", scrollTo);

    return () => node.current?.removeEventListener("click", scrollTo);

    function scrollTo(e: MouseEvent) {
      e.preventDefault();
    
      const element = document.getElementById(to);

      if(element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [node.current]);

  return (
    <a id={id} className={className} href={`#${to}`} ref={node} style={{ ...(style ?? {}) }}>
      <i className="fa fa-angle-double-up"></i>
    </a>
  );
}